
// import * as Moment from 'dayjs';

export const SUB_COMMON_COLUMS = [
  {
    title: '商品图片',
    dataIndex: 'image',
    key: 'image',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'imageList' },
  },
  {
    title: '商品编码',
    dataIndex: 'outSkuCode',
    key: 'outSkuCode',
    width: 160,
    ellipsis: true,
    customRender: (text, row) => {
      return ['XIAOZI_ERP', 'XIAOZI_MIDDLE'].includes(row.dockingSystem) ? text || '--' : row.skuCode || '--';
    },
  },
  {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 160,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '品牌名称',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 120,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '规格',
    dataIndex: 'specification',
    key: 'specification',
    width: 80,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '型号',
    dataIndex: 'model',
    key: 'model',
    width: 80,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '生产商',
    dataIndex: 'manufacturer',
    key: 'manufacturer',
    width: 140,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '厂家编码',
    dataIndex: 'factoryCode',
    key: 'factoryCode',
    width: 100,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '发货数量',
    dataIndex: 'quantity',
    key: 'quantity',
    width: 100,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  // {
  //   title: '生产日期',
  //   dataIndex: 'productionDate',
  //   key: 'productionDate',
  //   width: 120,
  //   ellipsis: true,
  //   customRender: (text) => {
  //     return text ? Moment(text).format('YYYY-MM-DD') : '--';
  //   },
  // },
  // {
  //   title: '失效日期',
  //   dataIndex: 'expiryDate',
  //   key: 'expiryDate',
  //   width: 120,
  //   ellipsis: true,
  //   customRender: text => {
  //     return text ? Moment(text).format('YYYY-MM-DD') : '--';
  //   },
  // },
  // {
  //   title: '生产批次号',
  //   dataIndex: 'productionBatchNumber',
  //   key: 'productionBatchNumber',
  //   width: 120,
  //   ellipsis: true,
  //   customRender: text => {
  //     return text || '--';
  //   },
  // },
  // {
  //   title: '生产序列号',
  //   dataIndex: 'productionSerialNumber',
  //   key: 'productionSerialNumber',
  //   width: 120,
  //   ellipsis: true,
  //   customRender: text => {
  //     return text || '--';
  //   },
  // },
  {
    title: '是否医疗件',
    dataIndex: 'medicalFlag',
    key: 'medicalFlag',
    width: 120,
    ellipsis: true,
    customRender: text => {
      return text ? '是' : '否';
    },
  },
  {
    title: '注册证号',
    dataIndex: 'certificateNumber',
    key: 'certificateNumber',
    width: 100,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
];
